export default __webpack_public_path__ + "static/amenagement-porche-bed92aac2b4aaaf3644cad00d67b710a.png";